// @flow

const Routes = {
  login: () => {
    return "/login";
  },
  listSyncObjects: () => {
    return "/";
  },
  editSyncObjects: () => {
    return `/objects/:object_name`;
  },
  createSyncObject: () => {
    return `/create`;
  }
};

export default Routes;



// WEBPACK FOOTER //
// ./src/lib/routes.js